import { useMemo } from 'react';
import { useSelector } from 'react-redux';

const useH2HConceptsOptions = () => {
  const conceptsH2H = useSelector((state) => state.resonance.conceptsH2H);

  const validConceptsH2H = useMemo(() => conceptsH2H?.filter((h2hNode) => !!h2hNode.header), [conceptsH2H]);

  const h2hConceptsOptions = useMemo(
    () =>
      validConceptsH2H?.map((h2hNode) => ({
        label: h2hNode.header,
        value: h2hNode.id,
      })),
    [validConceptsH2H],
  );

  if (!conceptsH2H) {
    return undefined;
  }

  return h2hConceptsOptions;
};

export default useH2HConceptsOptions;
